import { jsxs, jsx } from 'react/jsx-runtime';
import { isPresetGradientColor } from '@flex-design-system/fx-colors';
import { forwardRef } from 'react';
import { getColor } from '../utils/color.mjs';
import useId from './hooks/useId.mjs';
import { getID, FlexLinearGradient } from './shared/FlexLinearGradient.mjs';

const PhoneIcon = forwardRef(
  ({
    color: rawColor = "currentColor",
    size: sizeFromProps,
    type = "default",
    style,
    ...props
  }, forwardedRef) => {
    const { id } = useId();
    const isGradient = isPresetGradientColor(rawColor);
    const color = isGradient ? `url(#${getID(rawColor, id)})` : getColor(rawColor);
    const size = sizeFromProps ?? 24;
    if (type === "fill") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "m7.46 16.828-.019-.018-.252-.252-.018-.018C4.54 13.754 3.056 10.07 3.002 6.196L3 6.186c-.005-.384.1-.76.301-1.085.2-.323.488-.585.829-.753l.003-.002L6.823 3l1.187.369 2.063 3.736-.172 1.089-1 .936a12.775 12.775 0 0 0 5.969 5.97l.937-1.001 1.089-.172 3.736 2.064.368 1.186-1.348 2.693A2.034 2.034 0 0 1 17.814 21l-.009-.004c-3.874-.054-7.559-1.536-10.346-4.168Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    if (type === "default") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "m7.46 16.828-.019-.018-.252-.252-.018-.018C4.54 13.754 3.056 10.07 3.002 6.196L3 6.186c-.005-.384.1-.76.301-1.085.2-.323.488-.585.829-.753l.003-.002L6.823 3l1.187.369 2.063 3.736-.172 1.089-1 .936a12.775 12.775 0 0 0 5.969 5.97l.937-1.001 1.089-.172 3.736 2.064.368 1.186-1.348 2.693A2.034 2.034 0 0 1 17.814 21l-.009-.004c-3.874-.054-7.559-1.536-10.346-4.168Zm1.24-1.296c2.456 2.315 5.706 3.624 9.135 3.67l.008.004a.22.22 0 0 0 .112-.033.241.241 0 0 0 .09-.098l.002-.005.963-1.926-2.37-1.31-.9.96-1.004.213a14.575 14.575 0 0 1-7.744-7.742l.213-1.005.96-.899-1.31-2.371-1.925.963-.005.002a.24.24 0 0 0-.097.09.22.22 0 0 0-.034.111l.002.01c.047 3.428 1.356 6.678 3.671 9.133l.234.233Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    console.error(
      `PhoneIcon doesn't support the combination of ${size} and ${type}`
    );
    return null;
  }
);

export { PhoneIcon };
//# sourceMappingURL=PhoneIcon.mjs.map
